(function () {
  function normalizeLotNumber(lotNumber) {
    if (!lotNumber) return '';
    return String(lotNumber).trim().toLowerCase().replace(/\s+/g, '');
  }

  function hideAllResults() {
    document.querySelectorAll('.coaform__content').forEach(function (content) {
      content.style.display = 'none';
    });
    const noContentMessage = document.querySelector('.coaform__no-content-message');
    if (noContentMessage) {
      noContentMessage.style.display = 'none';
    }
  }

  function findMatches(root, lotNumber) {
    return root.querySelectorAll('.coaform__content[data-coa-id*="' + CSS.escape(lotNumber) + '"]');
  }

  function showMatches(matches) {
    matches.forEach(function (content) {
      content.style.display = 'block';
    });
  }

  function showNoContent(lotNumber) {
    const noContentMessage = document.querySelector('.coaform__no-content-message');
    if (noContentMessage) {
      const lotLabel = noContentMessage.querySelector('#no-content-lot-number');
      if (lotLabel) {
        lotLabel.textContent = lotNumber.toUpperCase();
      }
      noContentMessage.style.display = 'block';
    }
  }

  // Cache of fetched remote pages (page number -> parsed Document promise),
  // so repeated searches don't refetch the same HTML.
  const pageCache = new Map();

  // Token used to discard results of outdated searches when the user
  // submits again before the previous search finishes.
  let searchToken = 0;

  // Fetch a specific page of the COA section
  function fetchPage(sectionId, pageParam, page) {
    if (pageCache.has(page)) {
      return pageCache.get(page);
    }

    const url =
      window.location.pathname +
      '?section_id=' + encodeURIComponent(sectionId) +
      '&' + encodeURIComponent(pageParam || 'page') + '=' + page;

    const promise = fetch(url)
      .then(function (response) {
        if (!response.ok) return null;
        return response.text();
      })
      .then(function (html) {
        if (!html) return null;
        return new DOMParser().parseFromString(html, 'text/html');
      })
      .catch(function () {
        pageCache.delete(page);
        return null;
      });

    pageCache.set(page, promise);
    return promise;
  }

  async function searchCoa(lotNumber) {
    const token = ++searchToken;
    hideAllResults();

    const wrapper = document.querySelector('.coaform__content-wrapper');
    if (!wrapper) {
      showNoContent(lotNumber);
      return;
    }

    // 1) Search entries already rendered on this page.
    const localMatches = findMatches(wrapper, lotNumber);
    if (localMatches.length > 0) {
      showMatches(Array.from(localMatches));
      return;
    }

    // 2) Not found locally: fetch the remaining pages in small parallel
    // batches, stopping as soon as a match is found. This stays fast for
    // a handful of pages and safe if the catalog grows to many pages.
    const sectionId = wrapper.dataset.sectionId;
    const pageParam = wrapper.dataset.pageParam;
    const totalPages = parseInt(wrapper.dataset.totalPages, 10) || 1;
    const currentPage = parseInt(wrapper.dataset.currentPage, 10) || 1;
    const BATCH_SIZE = 4;

    const pages = [];
    for (let page = 1; page <= totalPages; page++) {
      if (page !== currentPage) pages.push(page);
    }

    for (let i = 0; i < pages.length; i += BATCH_SIZE) {
      const batch = pages.slice(i, i + BATCH_SIZE);
      const docs = await Promise.all(
        batch.map(function (page) {
          return fetchPage(sectionId, pageParam, page);
        })
      );

      // A newer search started while we were fetching; drop these results.
      if (token !== searchToken) {
        return;
      }

      for (const doc of docs) {
        if (!doc) continue;
        const remoteMatches = findMatches(doc, lotNumber);
        if (remoteMatches.length > 0) {
          remoteMatches.forEach(function (match) {
            const imported = document.importNode(match, true);
            imported.style.display = 'block';
            wrapper.appendChild(imported);
          });
          return;
        }
      }
    }

    showNoContent(lotNumber);
  }

  // Check for lot_number URL parameter on page load
  const lotNumberParam = normalizeLotNumber(new URLSearchParams(window.location.search).get('lot_number'));

  if (lotNumberParam && lotNumberParam.length >= 4) {
    searchCoa(lotNumberParam);
  }

  // Handle form submission
  const coaForm = document.querySelector('.coaform-form');
  if (!coaForm) {
    return;
  }

  coaForm.addEventListener('submit', function (event) {
    event.preventDefault();

    const lotNumberInput = coaForm.querySelector('input[name="lot_number"]');
    const lotNumber = normalizeLotNumber(lotNumberInput ? lotNumberInput.value : '');

    if (!lotNumber || lotNumber.length < 4) {
      return;
    }

    searchCoa(lotNumber);

    // Reflect the search in the URL without reloading.
    const url = new URL(window.location.href);
    url.searchParams.set('lot_number', lotNumber);
    window.history.pushState({}, '', url);
  });
})();
